import { graphql } from '@/generated/gql';

export const PROCUREMENT_KNOWLEDGE_LIST_QUERY = graphql(/* GraphQL */ `
  query SevenbridgesDocumentList(
    $offset: Int
    $limit: Int
    $filter: SvbrgQueryBuilderQuery
    $order: [SvbrgDocumentListOrder!]
  ) {
    sevenbridges {
      documents(offset: $offset, limit: $limit, filter: $filter, order: $order)
        @connection(key: "procurementKnowledgeList") {
        nodes {
          id
          fileId
          fileName
          title
          description
          updatedAt
          language
          mimeType
          variant
          url
        }
        totalCount
      }
    }
  }
`);
